import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import { useTypedSelector } from '@/store/store';
import { selectCreditProductsData } from '@/store/reducers/detailed-car';
import { media } from '@/utils/mixin';

import { ResultProps } from './types';

function Result({ creditType }: ResultProps) {
  const creditProductsData = useTypedSelector(selectCreditProductsData);

  return (
    <Component>
      <b>Предложения по {creditType === 'credit' ? 'кредиту' : 'лизингу'}</b> (
      {creditProductsData &&
      creditProductsData.valid &&
      creditProductsData.valid.length > 0
        ? creditProductsData.valid.length
        : 0}
      )
    </Component>
  );
}

export default Result;

const Component = styled.p`
  z-index: 1;
  position: sticky;
  top: -20px;
  padding: 20px 0;
  font-size: 16px;
  line-height: 19px;
  background: ${(props) => props.theme.white};
  color: ${(props) => props.theme.black100};
  border-bottom: 1px solid ${colors.gray400};

  ${media.tablet(css`
    position: initial;
    padding: 20px 0 0;
    border-bottom: none;
  `)}

  b {
    font-weight: 500;
  }
`;
